import { Box, Hidden, Stack, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import i18n from '@utils/i18n';

// import BannerImgMobile from 'assets/images/main_mobile.png';
import RowLayout from '@components/RowLayout';

import useResponsive from '@hooks/useResponsive';
import { useInView } from 'react-intersection-observer';
import env from '@constants/env';

const BgImg = `${env.s3BaseUrl}/landing-page/homepage/mission-backgound.png`;
const VisionBgImg = `${env.s3BaseUrl}/landing-page/homepage/vision-background.png`;
const LineRight = `${env.s3BaseUrl}/landing-page/homepage/line-right.png`;
const LineLeft = `${env.s3BaseUrl}/landing-page/homepage/line-left.png`;

const styles = `
  @keyframes infiniteBounce-mobile {
    0%, 100% {
      opacity: 0.25;
      transform: translate(-50%, 10px);
    }
    50% {
      opacity: 1;
      transform: translate(-50%, -25px);
    }
  }
      @keyframes infiniteBounce-desktop {
    0%, 100% {
      opacity: 0.25;
      transform: translateY(, 10px);
    }
    50% {
      opacity: 1;
      transform: translateY( -25px);
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .background-image {
    transition: opacity 5ms ease-in;
    width: 100%;
    height: 100%;
    display: none;
    object-fit: cover;
    opacity: 0;
  }

 .active-mobile {
    opacity: 1;
    display: block;
    animation: infiniteBounce-mobile 4s ease-in-out infinite;
  }
     .active-desktop {
    opacity: 1;
    display: block;
    animation: infiniteBounce-desktop 4s ease-in-out infinite;
  }

  .tab-title {
    transition: color 0.3s ease-in-out;
  }
`;

const isEnglish = () => {
  const lang = localStorage.getItem('i18nextLng')?.toLowerCase() === 'en';
  return lang;
};

const Mission = () => {
  const bannerT = i18n.getFixedT(null, null, 'pages.landing');
  const { ref, inView, entry } = useInView({
    /* Optional options */
    triggerOnce: true,
    threshold: 0.5
  });
  const t = i18n.getFixedT(null, null, '');
  const isSm = useResponsive('down', 1000);
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <style>{styles}</style>
      <RowLayout
        sx={{
          width: '100%',
          height: { md: '1200px', xs: '860px', sm: '960px' },

          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'visible',
          zIndex: 0
        }}
      >
        <Hidden mdDown>
          <Stack
            sx={{
              pt: '335px',
              left: '50%',
              pb: '184px',

              zIndex: 1
            }}
          >
            <Stack
              sx={{
                position: 'relative',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              ref={ref}
            >
              <Box
                component="img"
                src={BgImg}
                className={`background-image ${
                  tabValue === 0 && inView ? 'active-desktop' : ''
                }`}
                loading="eager"
                alt="mission background"
              />
              <Box
                component="img"
                src={VisionBgImg}
                className={`background-image ${
                  tabValue === 1 && inView ? 'active-desktop' : ''
                }`}
                loading="eager"
                alt="vision background"
              />
              <Stack
                id="tab-stack"
                sx={{
                  flexDirection: {
                    md: 'column',
                    sm: 'column'
                  },
                  position: 'absolute',
                  left: '-10px',
                  top: '197px',
                  height: '100%',
                  alignItems: 'flex-start',
                  justifyContent: 'flex-start',
                  zIndex: 3
                }}
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-delay="500"
              >
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: {
                      display: 'none'
                    }
                  }}
                  sx={{
                    border: '0px solid #DEE2E6',
                    borderRadius: 0,
                    minHeight: '32px !important',
                    p: '0px !important'
                  }}
                >
                  <Tab
                    sx={{
                      minWidth: 0,
                      p: 0,
                      pr: 2.5,
                      minHeight: '32px !important',
                      pb: '0px !important',
                      position: 'relative'
                    }}
                    disableRipple
                    disableTouchRipple
                    label={
                      <Typography
                        className="tab-title"
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          fontSize: 32,
                          color: tabValue === 0 ? '#244EE2' : '#C8D1EE',
                          fontFamily: 'Swear Display',
                          fontStyle: 'italic',
                          textAlign: 'left',
                          lineHeight: '100%',
                          letterSpacing: '-1.6px'
                        }}
                      >
                        Mission
                      </Typography>
                    }
                  />
                  <Tab
                    sx={{
                      minWidth: 0,
                      px: 0,
                      py: 0,
                      pr: 2.5,
                      minHeight: '32px !important',
                      pb: '0px !important',
                      position: 'relative'
                    }}
                    disableRipple
                    disableTouchRipple
                    label={
                      <Typography
                        className="tab-title"
                        variant="body1"
                        sx={{
                          pl: 2.5,
                          fontWeight: 500,
                          fontSize: 32,
                          color: tabValue === 1 ? '#244EE2' : '#C8D1EE',
                          fontFamily: 'Swear Display',
                          fontStyle: 'italic',
                          textAlign: 'left',
                          lineHeight: '100%',
                          letterSpacing: '-1.6px'
                        }}
                      >
                        Vision
                      </Typography>
                    }
                  />
                </Tabs>

                <Stack sx={{ mt: 5, gap: 2.5 }}>
                  {tabValue === 0 &&
                    (isEnglish() ? (
                      <Stack sx={{ gap: 2.5 }} className="tab-content">
                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            New closest experience provided
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            to you through the power of data
                          </Typography>
                        </Stack>
                      </Stack>
                    ) : (
                      <Stack sx={{ gap: 2.5 }} className="tab-content">
                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            데이터의 힘을 통해
                          </Typography>
                          <img
                            src={LineRight}
                            alt="line right"
                            style={{ objectFit: 'contain', flexGrow: 1 }}
                          />
                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            가장 가까이에서 제공하는 새로운 소비
                          </Typography>
                        </Stack>
                      </Stack>
                    ))}
                  {tabValue === 1 &&
                    (isEnglish() ? (
                      <Stack sx={{ gap: 2.5 }} className="tab-content">
                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            Always a new experience
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            in your familiar space
                          </Typography>
                        </Stack>
                      </Stack>
                    ) : (
                      <Stack sx={{ gap: 2.5 }} className="tab-content">
                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            익숙한 공간에서 만나는
                          </Typography>
                        </Stack>

                        <Stack
                          sx={{
                            flexDirection: 'row',
                            gap: 2,
                            alignItems: 'center'
                          }}
                        >
                          <img
                            src={LineLeft}
                            alt="line right"
                            style={{ objectFit: 'contain', flexGrow: 1 }}
                          />
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '48px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-2.4px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            늘 새로운 세상
                          </Typography>
                        </Stack>
                      </Stack>
                    ))}

                  {/* Rest of the component remains the same */}
                </Stack>
                <Stack
                  sx={{
                    width: '100%',
                    minWidth: '664px',
                    alignItems: 'flex-end',
                    mt: 2.5,
                    display: isEnglish() ? 'none' : 'flex'
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="172"
                    height="28"
                    viewBox="0 0 172 28"
                    fill="none"
                  >
                    <path
                      d="M11.4634 10.1C11.2308 8.77615 10.7643 8.56785 9.62821 8.30433L9.69504 7.94922H17.9996L17.934 8.30433C16.7568 8.44989 16.2222 8.62682 16.1143 9.21659C16.0873 9.36466 16.0847 9.53908 16.1066 9.74612L17.2143 18.166H17.3351L20.7202 11.3648C21.0929 10.6007 21.2419 10.1 21.2792 9.89168C21.4463 8.97943 20.9335 8.53899 19.5276 8.30433L19.5944 7.94922H25.3852L25.321 8.30433C23.9947 8.44989 22.6993 9.06978 22.0246 10.3635L16.1503 21.7887H13.3718L11.9414 13.0149L7.04895 21.7887H4.33089L2.03822 10.1C1.77091 8.8025 1.30955 8.56785 0 8.30433L0.0629712 7.94922H8.51528L8.45103 8.30433C7.33039 8.44989 6.79578 8.62682 6.69297 9.18773C6.66855 9.33329 6.68269 9.57045 6.70967 9.74612L8.1593 18.2563H8.27753L11.8065 12.1303L11.4634 10.1Z"
                      fill="#313131"
                    />
                    <path
                      d="M32.1266 14.7502C32.8424 10.7774 32.6419 8.30294 30.6307 8.30294C28.6542 8.30294 27.7905 10.7774 27.0734 14.7502C26.3551 18.728 26.5491 21.2565 28.5578 21.2565C30.5073 21.2565 31.4082 18.728 32.1266 14.7502ZM22.2452 14.8104C23.0368 10.4223 26.3653 7.71191 30.8851 7.71191C35.5232 7.71191 37.7452 10.3056 36.9535 14.6925C36.1568 19.1095 32.8231 21.8462 28.3329 21.8462C23.6331 21.8462 21.4471 19.2262 22.2452 14.8104Z"
                      fill="#313131"
                    />
                    <path
                      d="M35.7312 21.256C37.4212 21.2271 37.799 20.9322 37.9263 20.2258L39.7666 10.0379C39.9259 9.15446 39.6972 8.62492 38.0175 8.59732L38.0805 8.2422L44.6449 7.88834L44.1437 10.659C45.3852 8.85957 47.1702 7.80176 48.7972 7.80176C50.6285 7.80176 51.4304 8.91981 51.1541 10.4507C50.8765 11.9828 49.7135 13.0419 48.3551 13.0419C46.7564 13.0419 46.0444 11.9226 46.2578 10.7456C46.3362 10.3039 46.5456 9.8032 46.732 9.41797C46.0136 9.4782 44.8673 10.2449 44.0975 11.245L42.4756 20.2258C42.3458 20.9322 42.7481 21.1694 45.0099 21.256L44.9456 21.6098H35.667L35.7312 21.256Z"
                      fill="#313131"
                    />
                    <path
                      d="M55.28 20.2268C55.1528 20.9333 55.5422 21.2281 56.5703 21.257L56.5061 21.6109H48.501L48.5639 21.257C50.2231 21.2281 50.6009 20.9333 50.7307 20.2268L53.9037 2.64798C54.063 1.76709 53.8625 1.23505 52.0646 1.20493L52.1289 0.854837L58.8411 0.500977L56.1514 15.3982L60.6416 11.3037C62.3778 9.7164 61.964 8.89198 60.2689 8.30221L60.3332 7.94835H67.1585L67.0917 8.30221C64.9288 8.83175 63.2093 9.86446 60.977 11.7492L60.3846 12.2474L63.8673 19.4626C64.596 20.9935 64.8697 21.1102 66.205 21.257L66.1407 21.6109H57.8966L57.9608 21.257C59.2087 21.1993 59.4721 20.9044 58.9928 19.7863L57.0098 15.2213L56.0229 16.1034L55.28 20.2268Z"
                      fill="#313131"
                    />
                    <path
                      d="M70.8517 13.9251H75.0464C76.0488 10.5082 75.7699 8.30224 74.1404 8.30224C72.606 8.30224 71.5971 10.4505 70.8517 13.9251ZM65.8731 14.9854C66.7098 10.3614 70.4084 7.70996 74.4283 7.70996C78.6512 7.70996 80.4324 10.4505 79.493 14.5136H70.7464L70.6731 14.9264L70.6603 14.9854C69.9907 18.6959 71.1589 20.5807 73.9939 20.5807C75.7353 20.5807 77.0718 19.7249 78.4379 18.2241L78.727 18.4299C76.9471 20.5807 74.7984 21.8443 71.9043 21.8443C67.5901 21.8443 65.0661 19.4614 65.8731 14.9854Z"
                      fill="#313131"
                    />
                    <path
                      d="M78.2937 21.256C79.9837 21.2271 80.359 20.9322 80.4888 20.2258L82.3265 10.0379C82.4884 9.15446 82.2597 8.62492 80.58 8.59732L80.643 8.2422L87.2074 7.88834L86.7062 10.659C87.9477 8.85957 89.7327 7.80176 91.3597 7.80176C93.191 7.80176 93.9929 8.91981 93.7166 10.4507C93.4416 11.9828 92.2747 13.0419 90.915 13.0419C89.3215 13.0419 88.6069 11.9226 88.8203 10.7456C88.8987 10.3039 89.1081 9.8032 89.2945 9.41797C88.5761 9.4782 87.4323 10.2449 86.66 11.245L85.0381 20.2258C84.9109 20.9322 85.3106 21.1694 87.5724 21.256L87.5081 21.6098H78.2295L78.2937 21.256Z"
                      fill="#313131"
                    />
                    <path
                      d="M93.0052 16.6663H93.4473C94.825 19.6666 96.2527 21.2577 98.3501 21.2577C99.7406 21.2577 100.67 20.5224 100.899 19.255C101.134 17.9601 100.491 17.4305 97.498 16.4894C94.5063 15.5458 93.3779 14.6047 93.7802 12.3673C94.2981 9.51007 96.8362 7.71191 100.233 7.71191C101.919 7.71191 103.196 8.15738 104.057 8.8011L105.138 7.71191H105.494L104.654 12.3673H104.209C102.968 9.74473 102.051 8.30294 100.127 8.30294C98.8577 8.30294 97.9106 9.12735 97.6702 10.4512C97.4518 11.6583 98.6559 12.1904 100.44 12.6308C103.552 13.3975 105.181 14.5156 104.724 17.0465C104.224 19.8159 101.404 21.8462 97.9478 21.8462C96.8529 21.8462 94.1991 21.1711 93.518 20.6993L92.4218 21.8462H92.0684L93.0052 16.6663Z"
                      fill="#313131"
                    />
                    <path
                      d="M109.456 21.256C111.114 21.2272 111.494 20.9323 111.621 20.2258L114.796 2.64826C114.955 1.76612 114.753 1.23533 112.955 1.20396L113.02 0.85386L119.733 0.5L117.893 10.6854C119.448 8.95123 121.634 7.80181 123.524 7.80181C126.154 7.80181 127.025 9.36281 126.515 12.1887L125.065 20.2258C124.935 20.9323 125.181 21.2272 126.887 21.256L126.823 21.6099H118.788L118.853 21.256C119.89 21.2272 120.387 20.9323 120.516 20.2258L121.96 12.215C122.236 10.6854 121.751 9.77314 120.422 9.77314C119.504 9.77314 118.691 10.3617 117.787 11.2764L116.172 20.2258C116.041 20.9323 116.434 21.2272 117.461 21.256L117.398 21.6099H109.392L109.456 21.256Z"
                      fill="#313131"
                    />
                    <path
                      d="M131.58 3.35706C131.872 1.73583 133.125 0.676758 134.693 0.676758C136.286 0.676758 137.141 1.6756 136.858 3.23785C136.566 4.85657 135.346 5.88553 133.751 5.88553C132.183 5.88553 131.286 4.97327 131.58 3.35706ZM126.634 21.2559C128.322 21.227 128.818 20.9334 128.946 20.2269L130.786 10.039C130.945 9.1556 130.6 8.62606 128.919 8.5972L128.983 8.24208L135.725 7.88822L133.497 20.2269C133.37 20.9334 133.581 21.227 135.292 21.2559L135.227 21.611H126.569L126.634 21.2559Z"
                      fill="#313131"
                    />
                    <path
                      d="M145.524 12.3664C145.988 9.80408 145.75 8.33092 144.212 8.33092C142.735 8.33092 142.23 9.50919 141.713 12.3664C141.197 15.2211 141.509 16.4283 143.017 16.4283C144.465 16.4283 145.009 15.2211 145.524 12.3664ZM145.914 24.1128C146.105 23.055 145.483 22.4063 143.062 22.4063H138.748C137.909 22.9634 137.452 23.5243 137.303 24.3475C136.961 26.2322 138.335 26.9675 141.173 26.9675C143.685 26.9675 145.586 25.9386 145.914 24.1128ZM147.16 8.21422C148.127 6.6231 149.571 5.32812 151.17 5.32812C152.406 5.32812 152.927 6.06345 152.745 7.06605C152.598 7.88796 151.933 8.6258 150.899 8.6258C150.13 8.6258 149.395 7.9482 149.59 6.85776C148.953 7.12378 148.195 7.71103 147.656 8.42001C149.272 9.12647 150.187 10.4215 149.849 12.3062C149.331 15.1634 146.407 16.9578 142.804 16.9578C142.125 16.9578 141.515 16.9001 140.94 16.811C139.699 17.1348 139.215 17.5175 139.11 18.1072C139.002 18.6958 139.658 18.9906 141.404 18.9906H144.857C148.08 18.9906 149.522 20.1664 149.096 22.523C148.612 25.2033 145.036 27.4996 140.309 27.4996C136.645 27.4996 134.092 26.4104 134.401 24.7026C134.625 23.4666 135.616 22.7288 138.043 22.3774L138.054 22.3172C136.388 21.7274 135.908 20.4613 136.103 19.3708C136.28 18.4009 137.7 17.0745 140.06 16.6052C138.11 15.9565 136.993 14.6038 137.388 12.4241C137.898 9.59578 140.822 7.80138 144.458 7.80138C145.46 7.80138 146.383 7.9482 147.16 8.21422Z"
                      fill="#313131"
                    />
                    <path
                      d="M148.909 21.256C150.567 21.2272 150.945 20.9323 151.074 20.2258L154.249 2.64826C154.408 1.76612 154.206 1.23533 152.408 1.20396L152.473 0.85386L159.186 0.5L157.346 10.6854C158.901 8.95123 161.087 7.80181 162.977 7.80181C165.607 7.80181 166.478 9.36281 165.968 12.1887L164.518 20.2258C164.391 20.9323 164.634 21.2272 166.341 21.256L166.276 21.6099H158.242L158.306 21.256C159.343 21.2272 159.838 20.9323 159.969 20.2258L161.413 12.215C161.69 10.6854 161.204 9.77314 159.875 9.77314C158.957 9.77314 158.144 10.3617 157.238 11.2764L155.625 20.2258C155.497 20.9323 155.887 21.2272 156.914 21.256L156.851 21.6099H148.845L148.909 21.256Z"
                      fill="#313131"
                    />
                    <path
                      d="M172 0.5L165.286 0.85386L165.225 1.19643C165.289 1.19643 165.349 1.21274 165.414 1.21525C165.631 1.22403 165.844 1.24411 166.054 1.27799C168.489 1.672 170.352 3.72238 170.352 6.21321C170.352 6.37633 170.323 6.52189 170.318 6.68H170.884L172 0.5Z"
                      fill="#313131"
                    />
                    <path
                      d="M165.223 1.2041C165.295 1.2054 165.35 1.21321 165.416 1.21581C165.351 1.21321 165.291 1.19629 165.224 1.19629L165.223 1.2041Z"
                      fill="#313131"
                    />
                  </svg>
                </Stack>
              </Stack>
              <Stack
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-delay="300"
                data-aos-duration="300"
                data-aos-once="true"
              >
                <Typography
                  variant="body1"
                  sx={{
                    mt: 5,
                    textAlign: 'center',
                    color: '#000',
                    fontSize: '18px',
                    fontWeigt: 500,
                    lineHeight: '130%',
                    letterSpacing: '-0.9px'
                  }}
                >
                  {t('pages.flagshop.mission.subtitle')}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Hidden>
        <Hidden mdUp>
          <Stack
            sx={{
              width: '100%',
              pt: { xs: '150px', sm: '180px' },
              overflow: 'visible',

              zIndex: 1
            }}
          >
            <Stack
              sx={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'visible',
                minHeight: '620px',
                alignItems: 'center'
              }}
              ref={ref}
            >
              <Box
                component="img"
                src={BgImg}
                className={`background-image ${
                  tabValue === 0 && inView ? 'active-mobile' : ''
                }`}
                sx={{
                  position: 'absolute',
                  top: '0px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  objectFit: 'cover',
                  width: '100%',
                  height: '100%',
                  maxWidth: '620px'
                }}
                loading="eager"
                alt="mission background"
              />
              <Box
                component="img"
                src={VisionBgImg}
                className={`background-image ${
                  tabValue === 1 && inView ? 'active-mobile' : ''
                }`}
                sx={{
                  position: 'absolute',
                  top: '50px',
                  left: '50%', // Center horizontally
                  transform: 'translateX(-50%)', // Keep this for horizontal centering
                  maxWidth: { xs: '600px', sm: '620px' },
                  height: '600px'
                }}
                loading="eager"
                alt="vision background"
              />
              <Stack
                id="tab-stack"
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  flexDirection: {
                    md: 'column',
                    sm: 'column'
                  },
                  px: { xs: '20px', sm: 5 },

                  height: '100%',
                  alignItems: { xs: 'flex-start', sm: 'flex-start' },
                  justifyContent: 'center',

                  zIndex: 3
                }}
                data-aos="fade-up"
                data-aos-offset="0"
                data-aos-duration="600"
                data-aos-once="true"
                data-aos-delay="500"
              >
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  TabIndicatorProps={{
                    style: {
                      display: 'none'
                    }
                  }}
                  sx={{
                    border: '0px solid #DEE2E6',
                    borderRadius: 0,
                    minHeight: '32px !important',
                    p: '0px !important'
                  }}
                >
                  <Tab
                    sx={{
                      minWidth: 0,
                      p: 0,
                      pr: 2.5,
                      minHeight: '32px !important',
                      pb: '0px !important',
                      position: 'relative'
                    }}
                    disableRipple
                    disableTouchRipple
                    label={
                      <Typography
                        className="tab-title"
                        variant="body1"
                        sx={{
                          fontWeight: 500,
                          fontSize: 32,
                          color: tabValue === 0 ? '#244EE2' : '#C8D1EE',
                          fontFamily: 'Swear Display',
                          fontStyle: 'italic',
                          textAlign: 'left',
                          lineHeight: '100%',
                          letterSpacing: '-1.6px'
                        }}
                      >
                        Mission
                      </Typography>
                    }
                  />
                  <Tab
                    sx={{
                      minWidth: 0,
                      px: 0,
                      py: 0,
                      pr: 2.5,
                      minHeight: '32px !important',
                      pb: '0px !important',
                      position: 'relative'
                    }}
                    disableRipple
                    disableTouchRipple
                    label={
                      <Typography
                        className="tab-title"
                        variant="body1"
                        sx={{
                          pl: 2.5,
                          fontWeight: 500,
                          fontSize: 32,
                          color: tabValue === 1 ? '#244EE2' : '#C8D1EE',
                          fontFamily: 'Swear Display',
                          fontStyle: 'italic',
                          textAlign: 'left',
                          lineHeight: '100%',
                          letterSpacing: '-1.6px'
                        }}
                      >
                        Vision
                      </Typography>
                    }
                  />
                </Tabs>

                <Stack sx={{ mt: 5, gap: 2.5 }}>
                  {tabValue === 0 &&
                    (isEnglish() ? (
                      <Stack sx={{ gap: 2.5 }} className="tab-content">
                        <Stack
                          sx={{
                            flexDirection: 'column',

                            alignItems: 'flex-start',
                            gap: '4px'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '30px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '130%',
                              letterSpacing: '-1.5px',
                              whiteSpace: 'pre-line',
                              wordBreak: 'keep-all', // Prevent breaking words
                              overflowWrap: 'break-word'
                            }}
                          >
                            New closest experience provided to you through the
                            power of data
                          </Typography>
                        </Stack>
                      </Stack>
                    ) : (
                      <Stack
                        sx={{ gap: 2.5, minWidth: { sm: '452px' } }}
                        className="tab-content"
                      >
                        <Stack
                          sx={{
                            flexDirection: 'column',

                            alignItems: 'flex-start'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '30px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '130%',
                              letterSpacing: '-1.5px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            데이터의 힘을 통해
                          </Typography>

                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '30px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '130%',
                              letterSpacing: '-1.5px',
                              whiteSpace: { xs: 'pre-line', sm: 'nowrap' }
                            }}
                          >
                            {`  가장 가까이에서\n제공하는 새로운 소비`}
                          </Typography>
                        </Stack>
                      </Stack>
                    ))}
                  {tabValue === 1 &&
                    (isEnglish() ? (
                      <Stack sx={{ gap: 2.5 }} className="tab-content">
                        <Stack
                          sx={{
                            flexDirection: 'column',
                            gap: 0.5,
                            alignItems: 'flex-start'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '30px',
                              color: '#313131',
                              minHeight: '117px',
                              fontWeight: 700,
                              lineHeight: '100%',
                              letterSpacing: '-1.5px',
                              whiteSpace: 'pre-line',
                              wordBreak: 'keep-all', // Prevent breaking words
                              overflowWrap: 'break-word'
                            }}
                          >
                            Always a new experience in your familiar space
                          </Typography>
                        </Stack>
                      </Stack>
                    ) : (
                      <Stack
                        sx={{ gap: 2.5, minWidth: '452px' }}
                        className="tab-content"
                      >
                        <Stack
                          sx={{
                            flexDirection: 'column',

                            alignItems: 'flex-start'
                          }}
                        >
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '30px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '130%',
                              letterSpacing: '-1.5px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            익숙한 공간에서 만나는
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: '30px',
                              color: '#313131',
                              fontWeight: 700,
                              lineHeight: '130%',
                              letterSpacing: '-1.5px',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            늘 새로운 세상
                          </Typography>
                        </Stack>
                      </Stack>
                    ))}
                  <Stack
                    data-aos="fade-up"
                    data-aos-offset="0"
                    data-aos-delay="300"
                    data-aos-duration="300"
                    data-aos-once="true"
                  >
                    <Typography
                      variant="body1"
                      sx={{
                        mt: 5,
                        textAlign: 'left',
                        color: '#000',
                        fontSize: '18px',
                        fontWeigt: 500,
                        lineHeight: '150%',
                        letterSpacing: '-0.9px',
                        whiteSpace: 'pre-line',
                        wordBreak: 'keep-all', // Prevent breaking words
                        overflowWrap: 'break-word'
                      }}
                    >
                      {t('pages.flagshop.mission.subtitle-mobile')}
                    </Typography>
                  </Stack>
                  {/* Rest of the component remains the same */}
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Hidden>
      </RowLayout>
    </>
  );
};

export default Mission;
